import * as yup from "yup";


export const createContactValidationSchema = (params: { translate: any }) => {
  const { translate } = params;

  const schema = yup.object().shape({
    firstName: yup.string().nullable().required(translate("youMustEnterAFirstName")),
    lastName: yup.string().nullable().required(translate("youMustEnterALastName")),
    email: yup.string().nullable().required(translate("youMustEnterAEmail")),
    contactType: yup.string().nullable().required(translate("youMustEnterAContactType")),
  });

  return schema;
}
